import { DangerousHtmlContent, Notification } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { TripChange } from '@eti/types';
import { getPriceNotificationContent } from '../../../../utils/notification';

const isHigherPrice = ({ priceNew, priceOld }) => priceNew > priceOld;

const PriceChangeNotification = ({ tripChange = {} }) => {
  const { t } = useTranslation();
  const { price } = tripChange;

  return Boolean(price) && isHigherPrice(price) ? (
    <Notification
      className="priceNotification"
      dataTestId="travelerDetails-priceChange-TripNotification"
    >
      <DangerousHtmlContent
        content={getPriceNotificationContent({
          tripChange,
          higherText: t('Notification.PriceIncrease.Message'),
        })}
      />
    </Notification>
  ) : null;
};

PriceChangeNotification.propTypes = {
  tripChange: TripChange,
};

export default PriceChangeNotification;
